import { render, staticRenderFns } from "./BackButtonDisplay.vue?vue&type=template&id=52557cff&scoped=true"
import script from "./BackButtonDisplay.vue?vue&type=script&lang=js"
export * from "./BackButtonDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52557cff",
  null
  
)

export default component.exports